/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum OperationsTaskResolutionChannel {
  CarrierPortal = "carrier_portal",
  CarrierEmail = "carrier_email",
  Operations = "operations",
  Automatic = "automatic",
}

export function instanceOfOperationsTaskResolutionChannel(value: any): boolean {
  for (const key in OperationsTaskResolutionChannel) {
    if (
      Object.prototype.hasOwnProperty.call(OperationsTaskResolutionChannel, key)
    ) {
      if (
        OperationsTaskResolutionChannel[
          key as keyof typeof OperationsTaskResolutionChannel
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OperationsTaskResolutionChannelFromJSON(
  json: any,
): OperationsTaskResolutionChannel {
  return OperationsTaskResolutionChannelFromJSONTyped(json, false);
}

export function OperationsTaskResolutionChannelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationsTaskResolutionChannel {
  return json as OperationsTaskResolutionChannel;
}

export function OperationsTaskResolutionChannelToJSON(
  value?: OperationsTaskResolutionChannel | null,
): any {
  return value as any;
}

export function OperationsTaskResolutionChannelToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OperationsTaskResolutionChannel {
  return value as OperationsTaskResolutionChannel;
}
